module.exports = __webpack_public_path__ + "static/media/1.89593f92.png";